// import "./$http";
const files = require.context(".", false, /\.js$/)
let configApi = {}

files.keys().forEach(key => {
  if (key === './index.js') return
  Object.assign(configApi, files(key))
})
module.exports = configApi